import { render, staticRenderFns } from "./ConvProspettiPaghe.vue?vue&type=template&id=40c9ef0c&scoped=true"
import script from "./ConvProspettiPaghe.vue?vue&type=script&lang=js"
export * from "./ConvProspettiPaghe.vue?vue&type=script&lang=js"
import style0 from "./ConvProspettiPaghe.vue?vue&type=style&index=0&id=40c9ef0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9ef0c",
  null
  
)

export default component.exports